// actions.js

export const updateBasicDetails = (type,details) => ({
  type: type,
  //"UPDATE_BASIC_DETAILS",
  payload: details,
});

export const updateAssetSpecification = (type,details) => ({
  //type: "UPDATE_ASSET_SPECIFICATION",
  type: type,
  payload: details,
});

export const updatePurchaseDetails = (type,details) => ({
 /// type: "UPDATE_PURCHASE_DETAILS",
 type: type,
  payload: details,
});

export const updateAttachmentDetails = (type,details) => ({
  //type: "UPDATE_ATTACHMENT_DETAILS",
  type: type,
  payload: details,
});

export const removeAttachmentDetails = (type,details) => ({
  type: 'REMOVE_ATTACHMENT_DETAILS',
  payload: details,
});

export const clearAttachmentDetails=(type,details)=>({
  type: 'CLEAR_ATTACHMENT_DETAILS', 
  payload: details
});

export const mandatoryFields = (details, type) => ({
  type: type,
  payload: details,
});

// Example of how updateFilterDetails might look
export const updateFilterDetails = (filterDetails) => ({
  type: 'UPDATE_WORKORDER_REPORTS_DETAILS', // Replace with your actual action type
  payload: filterDetails,
});


export const gridValues = (details) => ({
  type: "GRID_DATA",
  payload: details,

  
});
export const assetNumberGeneraation = (details) => ({
  type: 'ASSET_NUMBER_GENERATION',
  payload: details,
});

export const newHisotricalCostData = (details) => ({
  type: 'NEW_HISTORICAL_COST_DATA',
  payload: details,
});


export const SET_FINAL_WORK_ORDER_JSON = 'SET_FINAL_WORK_ORDER_JSON';

export const serviceType = (details) => ({
  type: 'SERVICE_TYPE',
  payload: details,
});

export const setFinalWorkOrderJSON = (sections) =>{
 return {
 
  type: SET_FINAL_WORK_ORDER_JSON,
  payload: sections,
};
};

export const updateAssetDetails = (assetDetails) => ({
  type: "UPDATE_ASSET_REPORTS_DETAILS", // Replace with your actual action type
  payload: assetDetails,
});

export const SET_FINAL_ASSET_ANALYSIS_JSON = 'SET_FINAL_ASSET_ANALYSIS_JSON';

export const setFinalAssetAnalysisJSON = (sections) =>{
 return {
 
  type: SET_FINAL_ASSET_ANALYSIS_JSON,
  payload: sections,
};
};